import {Typography, useTheme} from "@mui/material";
import React from "react";

export const ErrorText = ({children, sx}) => {
    const theme = useTheme();

    return <Typography sx={{
        padding: "5px 0px 0px 20px",
        color: theme.palette.error.main,
        ...sx
    }}>
        {children}
    </Typography>
}